import { Box, Button, Checkbox, Divider, Grid, Paper, Radio, RadioGroup, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import '../CastPoll/CastPollForm.css'
import { headingBlue, maroon } from '../../../assets/colors'
import CustomTextField from '../../CustomTextField'
import CustomPasswordTextField from '../../CustomPasswordTextField'
import { button2Style, buttonStyle, errorTextStyle } from '../../../utils/commonCSS'
import { castVote, getElectionDetails, voterFinalLogin, voterLogin } from '../../../backend/backendApis'
import { useNavigate, useParams } from 'react-router-dom'
import HttpService from '../../../backend/requestApis'
import { sendOtp, verifyOTP } from '../../../utils/commonFunctions'
import { BorderBottom, CheckBox } from '@mui/icons-material'
import Loader from '../../Loader'
import CustomDropDown from '../../CustomDropDown'
import { countryCodes } from '../../../utils/constants'

const CastVoteForm = () => {
    const {id} = useParams()
    const [isUserVerified, setIsUserVerified] = useState(false)
    const [isOTPVerfied, setIsOTPVerified] = useState(false)

    const [contactNumber, setContactNumber] = useState('')
    const [countryCode, setCountryCode] = useState('+91')
    const [password, setPassword] = useState('')
    const [enteredOTP, setEnteredOTP] = useState('')
    const [confirmationResult, setConfirmationResult] = useState(null)

    const [token, setToken] = useState(null)

    const [electionDetails, setElectionDetails] = useState([])
    const [candidatesList, setCandidatesList] = useState([])
    const [selectedCandidate, setSelectedCandidates] = useState(0)
    const [selCandidatesMsg, setSelCandidateMsg] = useState('')
    const [checkBoxActiveStatus, setCheckBoxStatus] = useState(true)
    const [isVoteCasted, setIsVoteCasted] = useState(false)

    const [isLoading, setIsLoading] = useState(false)
    const [apiError, setApiError] = useState('')

    const navigate = useNavigate()

    const updateUserName = (value) => {
        setContactNumber(value)
    }

    const updateCountryCode = (value) =>{
        setCountryCode(value)
    }

    const updatePassword = (value) => {
        setPassword(value)
    }

    const updateOTP = (value) => {
        setEnteredOTP(value)
    }

    const updateCandidateSelection = (contactNumber, val) => {
        let isValid = true
        if( val){
            if(selectedCandidate === electionDetails?.numOfPosts){
                setSelCandidateMsg(`Cannot Choose more than ${electionDetails?.numOfPosts}`)
                setCheckBoxStatus(false)
                isValid = false
            }
        }
        if( isValid){
            setSelCandidateMsg('')
            setCheckBoxStatus(true)
            let result = candidatesList?.map((ele) =>  {
                if( ele.candidateCN === contactNumber){
                    if( val){
                        setSelectedCandidates(selectedCandidate + 1)
                    }else {
                        setSelectedCandidates(selectedCandidate - 1)
                    }
                    return {...ele, value: !(ele.value)}
                } else {
                    return ele
                }
            })
            setCandidatesList(() => result)
         }
    }

    const verifyUser = () => {
        setIsLoading(() => true)
        let options = {
            url: voterLogin,
            method: 'GET',
            params: {
                contactNumber: contactNumber,
                id: id,
                password: password
            }
        }
        HttpService(options).then(async (respStatus) => {
            try{
                let OTPResult = await sendOtp(contactNumber, countryCode)
                setConfirmationResult(OTPResult)
                setIsUserVerified(true)
                setApiError(() => '')
                setIsLoading(false)
            } catch(err) {
                console.log("Error : ", err)
                if( err?.msg === 'auth/too-many-requests'){
                    setApiError('Too Many Attempts. Try again after sometime.')    
                } else
                    setApiError('Please Refresh and Try again, If issue Persist Contact Support.')
                setIsLoading(() => false)
            }
        }).catch(err => {
            console.log("Error in Verifying User: ", err)
            setApiError(err?.response?.data?.message || 'Error in verifying User. Please Contact Support.')
            setIsLoading(() => false)
        })
    }

    const handleVerifyOTP = async () => {
        setIsLoading(() => true)
        try{
            let result = await verifyOTP(confirmationResult, enteredOTP)
            if( result){
                handleVoterLogin(result)
            }

        } catch(err){
            console.log('Error in verifying OTP: ', err)
            if (err?.msg && err?.msg === "auth/invalid-verification-code") {
                setApiError("Wrong OTP");
            } else if (err?.msg && err?.msg === "auth/code-expired") {
                setApiError("OTP expired.");
            } else {
                setApiError("Error in verifying OTP. Please refresh and try again.");
            }
            setIsLoading(false)
        }
    }

    const handleVoterLogin = (token) => {
        setIsLoading(() => true)
        let options = {
            url: voterFinalLogin,
            method: 'POST',
            payload: {
                id: id,
                contactNumber: contactNumber
            },
            headers: {
                headers: {
                Authorization:`Bearer ${token}`
            }
        }}
        HttpService(options).then(resp => {
            setToken(resp?.data?.data?.token)
            fetchElectionDetails(resp?.data?.data?.token)
        }).catch(err => {
            console.log("Error in Final login: ", err)
            setApiError(err?.response?.data?.message || 'Please refresh and try again. If issue persist contact support.')
            setIsLoading(false)
        })
    }

    const fetchElectionDetails = (token) => {
        setIsLoading(() => true)
        let options = {
            url: getElectionDetails + id,
            method: 'GET',
            params: {
                contactNumber: contactNumber
            },
            headers: {
                Authorization:  `Bearer ${token}`
            }
        }
        HttpService(options).then((resp) => {
            setElectionDetails(resp?.data?.data)
            let candidateArray = []
            resp?.data?.data?.candidateList?.map(ele => {
                let Obj = {
                    candidateName: ele?.candidateName,
                    candidateCN: ele?.candidateCN,
                    value: false
                }
                candidateArray.push(Obj)
            })
            setApiError(() => '')
            setCandidatesList(() => candidateArray)
            setIsOTPVerified(true)
            setIsLoading(false)
        }).catch(err => {
            if( err?.status === 403){
                localStorage.clear()
                setIsLoading(false)
                navigate(`/castevote/id/${id}`)
            } else {
                console.log('Error in fetching the election details: ', err)
                setApiError(err?.response?.data?.message || 'Internal Server Error. Please Contact Support.')
                setIsLoading(false)
            }
        })
    }

    const handleCastVote = () => {
        setIsLoading(() => true)
        let selCandidates = candidatesList.filter((cdt) =>  cdt?.value)
        if( selCandidates?.length === 0){
            setApiError('Choose atleast one candidate.')
            setIsLoading(() => false)
        } else {
            let options = {
                url: castVote,
                method: 'POST',
                payload: {
                    candidatesList: selCandidates
                },
                headers: {
                    headers: {
                        Authorization: `Beare ${token}`
                    }
                }
            }
            HttpService(options).then(() => {
                setIsLoading(() => false)
                setApiError(() => '')
                setIsVoteCasted(true)
            }).catch(err => {
                if( err?.status === 403){
                    localStorage.clear()
                    setIsLoading(false)
                    navigate(`/castevote/id/${id}`)
                } else {
                    console.log("Error in casting vote: ", err)
                    setApiError(err?.response?.data?.message || 'Internal Server Error. Please Contact Support.')
                    setIsLoading(false)
                }
            })
        }
    }

  return (
    <>
        <Box className = 'formContainer'>
            <Box className='formOuterBox'>
                <Box className='formImageContainer'>
                    <img
                        src={require("../../../assets/images/WORK_logo.png")} 
                        alt="Logo"
                        style={{width: '40%'}}
                        >
                    </img>
                </Box>
                {isLoading && <Loader></Loader>}
                <div id="recaptcha-container"></div>
                <Paper className= 'formBodyBox' sx={{alignItems: 'center'}}>
                    {!isUserVerified && 
                        <>
                            <Box className = 'formHeaderBox'>
                                <Typography style={{color: headingBlue, fontSize: '1rem', fontWeight: 600}}>
                                    Login With Your WORKers Portal Credentials
                                </Typography>
                            </Box>
                            <Box style={{width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                <Box style={{display: 'flex', flexDirection: 'row', width: '18rem', justifyContent: 'space-evenly'}}>
                                    <CustomDropDown 
                                        list={countryCodes} regular={true} width= '7rem'
                                        value={countryCode}
                                        setFunc={updateCountryCode}
                                    ></CustomDropDown>
                                    <CustomTextField width='10rem' placeHolder='Contact Number'
                                        value={contactNumber}
                                        setFunc = {updateUserName}
                                    ></CustomTextField>
                                </Box>
                                <CustomPasswordTextField placeHolder = 'Password'
                                    value = {password}
                                    setFunc = {updatePassword}
                                ></CustomPasswordTextField>
                            </Box>
                            <Box>
                                <Button style={buttonStyle}
                                    onClick={() => {verifyUser()}}
                                > Submit </Button>
                            </Box>
                        </>
                    }

                    {isUserVerified && !isOTPVerfied && 
                        <>
                            <Box style={{width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                <Typography style={{color: headingBlue, padding: '0.1rem 0.1rem 0.5rem 0.1rem'}}> Enter the OTP sent to xxxxxxx{contactNumber[7]}{contactNumber[8]}{contactNumber[9]} </Typography>
                                <CustomTextField placeHolder= 'Enter the OTP' value={enteredOTP} setFunc={updateOTP}></CustomTextField>
                                <Button 
                                    style={{...buttonStyle, marginTop: '0.75rem'}}
                                    onClick = {() => handleVerifyOTP()}    
                                >Submit </Button>
                            </Box>
                        </>
                    }

                    {  isUserVerified && isOTPVerfied && 
                        <>
                            { !(isVoteCasted) ? 
                            <>
                                <Box style={{width: '100%', display: 'flex', borderBottom: '1px solid #D3D3D3'}}>
                                    <Box style={{width: '40%', display: 'flex', justifyContent: 'flex-start', padding: '0rem 0rem 0.35rem 0rem'}}>
                                        <Typography style={{fontSize: '1.1rem', color: headingBlue}}><strong>{electionDetails?.['electionName']}</strong></Typography>
                                    </Box>
                                    <Box style={{width: '60%', display: 'flex', justifyContent: 'flex-end', padding: '0rem 0.5rem 0.35rem 0rem'}}>
                                        <Typography style={{fontSize: '1.1rem', color: maroon}}><strong> Posts: {electionDetails?.['numOfPosts']}</strong></Typography>
                                    </Box>
                                </Box>
                                
                                <Box style={{marginTop: '0.5rem', height: '20rem', overflow: 'auto', scrollbarWidth: 'none' }}>
                                    {
                                        candidatesList?.map((candidate) => {
                                            return <>
                                                <Grid container spacing={1}>
                                                    <Grid item xs={1} sm={1}>
                                                        <Checkbox 
                                                            style={{padding: '0.1rem'}}
                                                            checked={candidate?.value}
                                                            disabled={!checkBoxActiveStatus && !(candidate?.value)}
                                                            onChange={() => {
                                                                updateCandidateSelection(candidate.candidateCN, !(candidate?.value))
                                                            }}
                                                        ></Checkbox>
                                                    </Grid>
                                                    <Grid item xs={6} sm={6}>
                                                        <Typography style={{padding: '0.15rem'}}>
                                                            {candidate?.candidateName}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={4} sm={4}>
                                                        <Typography style={{padding: '0.15rem'}}>
                                                            {candidate?.candidateCN}
                                                        </Typography>
                                                    </Grid>

                                                </Grid>
                                            </>
                                            
                                        })
                                    }
                                
                                    <Box style={{display: 'flex', justifyContent: 'center'}}>
                                        <Button style={{...buttonStyle, marginTop: '1rem'}}
                                            onClick={() => handleCastVote()}
                                        > Cast Your Vote</Button>
                                    </Box>
                                </Box>
                                <Box style={{display: 'flex', justifyContent: 'center', padding: '1rem 0.2rem 0rem 0.2rem'}}>
                                    <Typography style={{...errorTextStyle}}>{selCandidatesMsg}</Typography>
                                </Box>
                            </> :
                            <>
                                <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '7rem'}}>
                                    <Typography style={{textAlign: 'center', color: maroon}}>
                                        Alhamdulillah, Your Choice is Recorded Successfully.
                                    </Typography>
                                </Box>
                            
                            </>
                            
                        }

                        </>
                    }
                    {
                        <Box style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0.75rem 0.5rem 0.5rem 0.5rem'}}>
                            <Typography style={{...errorTextStyle}}>{apiError}</Typography>
                        </Box>
                    }

                </Paper>


            </Box>
        </Box>
    </>
  )
}

export default CastVoteForm
